import './Content.css';
import React from "react";
import ProgressBar from './widgets/ProgressBar.js';
import ScheduleBar from './widgets/ScheduleBar.js';
import ActiveWidget from './widgets/ActiveWidget.js'
import ChangeActiveBlock from './ChangeActiveBlock.js';
import SplashScreen from '../assets/components/SplashScreen.js';

function Content(props) {
    // let day={"wakeUpDetail": {"hoursOfSleep": 8, "wakeupTime": '7:01', "sleepQuality": 9}}

    if (props.userProfile.name===null) {
        return (<SplashScreen />)
    } else 

    return (
        <div className="content">
            <div className="column1">
                <ScheduleBar />
            </div>
            <div className="column2">
                <ActiveWidget  setActiveBlock={props.setActiveBlock} activeBlock={props.activeBlock} userProfile={props.userProfile} setUserProfile={props.setUserProfile}/>
                {/* <Routine type="evening"></Routine> */}
                <ChangeActiveBlock setActiveBlock={props.setActiveBlock} activeBlock={props.activeBlock}/>
            </div>
            <div className="column3">
                <ProgressBar />
            </div>
        </div>
    )
}

export default Content;